export const tabs = [
  {
    id: 'tripsData',
    href: '/globaladmin',
    title: 'Філії та підрозділи',
  },
  {
    id: 'visitorsTab',
    href: '/globaladmin/visitors',
    title: 'Відвідувачі електронної черги',
  },
  {
    id: 'delayReasonsTab',
    href: '/globaladmin/delay-reasons',
    title: 'Причини затримки',
  },
  // {
  //   id: 'settings',
  //   href: '/globaladmin/settings',
  //   title: 'Глобальні налаштування',
  // },
];
